import React, { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
//MUI icon
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

//pagination
import Pagination from "../../../pages/Pagination";

import { useAccess, FEATURES } from "../../../hooks/useAccess";

//Date Range Picker
import { DateRangePicker } from "react-date-range";
//Calendar Css
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

import dayjs from "dayjs";
import { connect, useSelector, useDispatch } from "react-redux";
import {
  getVibeWheelHistory,
  getVibeWheelStats,
  getVibeWheel,
  resetVibeWheelCoin,
} from "../../../store/VibeWheelHistory/action";

const rewardItemsMap = {
  0: "Star",
  1: "Sun",
  2: "Umbrella",
  3: "Shoes",
  4: "Bag",
  5: "Sunglasses",
  6: "Cloud",
  7: "Rainbow"
};

const VibeWheelHistory = (props) => {
  const { vibewheelHistory, pagination, vibeWheelStats, vibeWheel } =
    useSelector((state) => state.vibewheelHistory);

  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [date, setDate] = useState([]);
  const [sDate, setsDate] = useState("ALL");
  const [eDate, seteDate] = useState("ALL");

  const [activePage, setActivePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const { canView } = useAccess();

  useEffect(() => {
    props.getVibeWheelHistory(activePage, rowsPerPage, sDate, eDate);
    props.getVibeWheelStats(sDate, eDate);
    props.getVibeWheel();
  }, [activePage, rowsPerPage, sDate, eDate]);

  useEffect(() => {
    setData(vibewheelHistory);
  }, [vibewheelHistory]);

  useEffect(() => {
    $("#card").click(() => {
      $("#datePicker");
    });
  }, []);

  useEffect(() => {
    if (date.length === 0) {
      setDate([
        {
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        },
      ]);
    }
    $("#datePicker");
    setData(vibewheelHistory);
  }, [date, vibewheelHistory]);

  const getAllUser = () => {
    setActivePage(1);
    setsDate("ALL");
    seteDate("ALL");
    $("#datePicker");
  };

  const collapsedDatePicker = () => {
    $("#datePicker").toggleClass("collapse");
  };

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setActivePage(1);
    setRowsPerPage(value);
  };

  const handleResetCoin = () => {
    dispatch(resetVibeWheelCoin());
  };

  const handleRefresh = () => {
    props.getVibeWheelHistory(activePage, rowsPerPage, sDate, eDate);
    props.getVibeWheelStats(sDate, eDate);
    props.getVibeWheel();
  };

  return (
    <>
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3 className="mb-3 text-white">Vibe Wheel History</h3>
          </div>
          <div className="col-12 col-md-6 order-md-2 order-first">
            <nav
              aria-label="breadcrumb"
              className="breadcrumb-header float-start float-lg-end"
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard" className="text-danger">
                    Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Vibe Wheel History
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <div className="row">
            {canView(FEATURES.GAME_VIBE_WHEEL_SUMMARY_TOTAL_GAMES) && (
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="card stats-card">
                  <div className="card-body">
                    <div className="stats-info">
                      <h5 className="card-title">
                        {vibeWheelStats?.totalGames || 0}
                      </h5>
                      <p className="stats-text">Total Games</p>
                    </div>
                    <div className="stats-icon">
                      <i className="material-icons">videogame_asset</i>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {canView(FEATURES.GAME_VIBE_WHEEL_SUMMARY_DIAMONDS_WON) && (
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="card stats-card">
                  <div className="card-body">
                    <div className="stats-info">
                      <h5 className="card-title">
                        {vibeWheelStats?.totalDiamondsWon?.toLocaleString() || 0}
                      </h5>
                      <p className="stats-text">Total Diamonds Won</p>
                    </div>
                    <div className="stats-icon">
                      <i className="material-icons">stars</i>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {canView(FEATURES.GAME_VIBE_WHEEL_SUMMARY_DIAMOND_SPENT) && (
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="card stats-card">
                  <div className="card-body">
                    <div className="stats-info">
                      <h5 className="card-title">
                        {vibeWheelStats?.totalDiamondsSpent?.toLocaleString() || 0}
                      </h5>
                      <p className="stats-text">Total Diamonds Spent</p>
                    </div>
                    <div className="stats-icon">
                      <i className="material-icons">monetization_on</i>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {canView(FEATURES.GAME_VIBE_WHEEL_SUMMARY_HOUSE_PROFIT) && (
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="card stats-card">
                  <div className="card-body">
                    <div className="stats-info">
                      <h5 className="card-title">
                        {vibeWheelStats?.houseProfit?.toLocaleString() || 0}
                      </h5>
                      <p className="stats-text">House Profit (Diamonds)</p>
                    </div>
                    <div className="stats-icon">
                      <i className="material-icons">trending_up</i>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* <div className="col-lg-3 col-md-4 col-sm-6">
              <div className="card stats-card">
                <div className="card-body">
                  <div className="stats-info">
                    <h5 className="card-title">
                      {vibeWheelStats?.winRate ? vibeWheelStats.winRate.toFixed(2) : 0}%
                    </h5>
                    <p className="stats-text">Win Rate</p>
                  </div>
                  <div className="stats-icon">
                    <i className="material-icons">assessment</i>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header pb-0">
              <div className="row my-3">
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-8 float-left">
                  <div className="text-left align-sm-left d-md-flex d-lg-flex justify-content-start">
                    <button
                      className="btn btn-info"
                      style={{ marginRight: 5 }}
                      onClick={getAllUser}
                    >
                      All
                    </button>
                    <button
                      className="btn btn-success"
                      style={{ marginRight: 5 }}
                      onClick={handleRefresh}
                    >
                      <i className="fas fa-sync-alt"></i> Refresh
                    </button>
                    {canView(FEATURES.GAME_VIBE_WHEEL_ADMIN_DIAMONDS) && (
                      <button
                        className="btn btn-danger"
                        style={{ marginRight: 5 }}
                        onClick={handleResetCoin}
                      >
                        Reset Admin Diamonds
                      </button>
                    )}
                    <button
                      className="collapsed btn btn-info ml-5"
                      value="check"
                      data-toggle="collapse"
                      data-target="#datePicker"
                      onClick={collapsedDatePicker}
                    >
                      Analytics
                      <ExpandMoreIcon />
                    </button>
                    <p style={{ paddingLeft: 10 }} className="my-2 ">
                      {sDate !== "ALL" && sDate + " to " + eDate}
                    </p>
                  </div>
                </div>

                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 float-right">
                  <div className="d-flex justify-content-end mt-3">
                    {canView(FEATURES.GAME_VIBE_WHEEL_ADMIN_DIAMONDS) && (
                      <span className="text-danger me-3">
                        Admin Diamonds:
                        <span className="text-info">
                          &nbsp;&nbsp;{vibeWheel?.adminCoin?.toLocaleString() || 0}
                        </span>
                      </span>
                    )}
                    <span className="text-danger">
                      Total Records:
                      <span className="text-info">
                        &nbsp;&nbsp;{pagination?.totalRecords || 0}
                      </span>
                    </span>
                  </div>
                </div>
                <div
                  id="datePicker"
                  className="collapse mt-5 pt-5"
                  aria-expanded="false"
                >
                  <div className="container table-responsive">
                    <div key={JSON.stringify(date)}>
                      <DateRangePicker
                        onChange={(item) => {
                          setDate([item.selection]);
                          const dayStart = dayjs(
                            item.selection.startDate
                          ).format("YYYY-MM-DD");
                          const dayEnd = dayjs(item.selection.endDate).format(
                            "YYYY-MM-DD"
                          );
                          setActivePage(1);
                          setsDate(dayStart);
                          seteDate(dayEnd);
                        }}
                        showSelectionPreview={true}
                        moveRangeOnFirstSelection={false}
                        ranges={date}
                        direction="horizontal"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body card-overflow">
              <table className="table table-striped" style={{ borderCollapse: "collapse" }}>
                <thead className="text-center">
                  <tr>
                    <th>No</th>
                    <th>User</th>
                    <th>Unique ID</th>
                    <th>Diamonds Spent</th>
                    <th>Diamonds Won</th>
                    <th>Result</th>
                    <th>Balance</th>
                    <th>Round</th>
                    <th>Date</th>
                    <th>Info</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {data?.length > 0 ? (
                    data?.map((record, index) => {
                      const recordDate = dayjs(record?.createdAt).format("YYYY-MM-DD");
                      const recordTime = dayjs(record?.createdAt).format("HH:mm:ss");

                      return (
                        <React.Fragment key={record._id}>
                          <tr
                            data-toggle="collapse"
                            data-target={`#demo${index}`}
                            className="accordion-toggle pointer-cursor"
                          >
                            <td>{(activePage - 1) * rowsPerPage + index + 1}</td>
                            <td>
                              <div className="d-flex align-items-center justify-content-center">
                                <img
                                  src={record?.userId?.image}
                                  alt={record?.userId?.name}
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                    marginRight: "8px"
                                  }}
                                  onError={(e) => {
                                    e.target.src = "https://devadmin.vibelynk.com/storage/male.png";
                                  }}
                                />
                                {record?.userId?.name}
                              </div>
                            </td>
                            <td className="text-info">{record?.userId?.uniqueId}</td>
                            <td className="text-danger">{record?.diamondSpent?.toLocaleString()}</td>
                            <td className="text-success">{record?.diamondWon?.toLocaleString()}</td>
                            <td>
                              <span className={record?.isWin ? 'text-success fw-bold' : 'text-danger fw-bold'}>
                                {record?.isWin ? 'WIN' : 'LOSE'}
                              </span>
                            </td>
                            <td className="text-warning">{record?.totalBalance?.toLocaleString()}</td>
                            <td className="text-primary">{record?.round}</td>
                            <td>
                              <div className="text-info">{recordDate}</div>
                              <div className="text-muted" style={{ fontSize: "0.85em" }}>{recordTime}</div>
                            </td>
                            <td className="pointer-cursor">
                              <i className="fas fa-info-circle fa-lg text-primary"></i>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="10" className="hiddenRow">
                              <div
                                id={`demo${index}`}
                                className="accordian-body collapse"
                              >
                                <div className="p-3">
                                  <h6 className="text-danger mb-3">Bet Details</h6>
                                  <div className="row">
                                    <div className="col-md-6">
                                      <div className="card bg-dark border border-secondary">
                                        <div className="card-body p-2">
                                          <table className="table table-sm table-borderless mb-0">
                                            <thead>
                                              <tr>
                                                <th className="text-white">Position</th>
                                                <th className="text-white">Selected Item</th>
                                                <th className="text-white">Bet Amount</th>
                                                <th className="text-white">Status</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {record?.selectedItems?.length > 0 ? (
                                                record.selectedItems.map((item, idx) => {
                                                  const isWinningItem = item === record?.winningItem;
                                                  return (
                                                    <tr key={idx}>
                                                      <td className="text-white">{idx + 1}</td>
                                                      <td className="fw-bold text-info">{rewardItemsMap[item] || item}</td>
                                                      <td className="text-warning">
                                                        {record?.selectedBets?.[idx]?.toLocaleString()}
                                                      </td>
                                                      <td>
                                                        {isWinningItem ? (
                                                          <i className="fas fa-check-circle text-success"></i>
                                                        ) : (
                                                          <i className="fas fa-times-circle text-danger"></i>
                                                        )}
                                                      </td>
                                                    </tr>
                                                  );
                                                })
                                              ) : (
                                                <tr>
                                                  <td colSpan="4" className="text-center text-white">
                                                    No bet details available
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="card bg-dark border border-secondary">
                                        <div className="card-body">
                                          <h6 className="card-title text-info">Game Summary</h6>
                                          <ul className="list-unstyled">
                                            <li className="text-white"><strong>Winning Item:</strong> <span className="text-success">{record?.winningItem}</span></li>
                                            <li className="text-white"><strong>Round ID:</strong> <span className="text-info">{record?.roundId}</span></li>
                                            <li className="text-white"><strong>Net Result:</strong>
                                              <span className={record?.diamondWon - record?.diamondSpent >= 0 ? 'text-success' : 'text-danger'}>
                                                {' '}{(record?.diamondWon - record?.diamondSpent)?.toLocaleString()}
                                              </span>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="10" align="center">
                        Nothing to show!!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <Pagination
                activePage={activePage}
                rowsPerPage={rowsPerPage}
                userTotal={pagination?.totalRecords || 0}
                handleRowsPerPage={handleRowsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(null, {
  getVibeWheelHistory,
  getVibeWheelStats,
  getVibeWheel,
  resetVibeWheelCoin,
})(VibeWheelHistory);
